<!-- Auth Dropdown Overlay -->
<div 
  *ngIf="isOpen"
  class="fixed inset-0"
  style="z-index: 99999;"
  (click)="onBackdropClick()"
>
</div>

<!-- Auth Dropdown Content -->
<div 
  *ngIf="isOpen"
  class="auth-dropdown absolute top-full z-50 mt-3 w-80 bg-white rounded-2xl shadow-2xl border border-gray-100/50 transform transition-all duration-300 ease-out origin-top-right
         lg:right-0 
         max-lg:right-0 max-lg:w-72
         max-md:fixed max-md:top-16 max-md:right-4 max-md:w-80
         max-sm:fixed max-sm:top-16 max-sm:right-2 max-sm:w-72"
  (click)="$event.stopPropagation()"
  role="dialog"
  aria-modal="true"
  style="z-index: 100000;"
>
  <!-- Authenticated User Content -->
  <div *ngIf="isAuthenticated$ | async; else unauthenticatedContent">

    <!-- User Header -->
    <div class="px-4 py-4 flex items-center gap-3 border-b border-gray-100">
      <div class="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm">
        <span translate="no" class="text-white font-bold text-sm notranslate">{{ getInitials() }}</span>
      </div>
      <div class="min-w-0">
        <p translate="no" class="text-sm font-bold text-gray-900 truncate notranslate">{{ getFullName() }}</p>
        <p translate="no" class="text-xs text-gray-400 truncate notranslate">{{ (currentUser$ | async)?.company || (currentUser$ | async)?.email }}</p>
      </div>
    </div>

    <!-- Menu Items -->
    <div class="py-2">

      <!-- My Orders -->
      <button
        (click)="navigateToOrders()"
        class="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors duration-150 group cursor-pointer">
        <span class="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 group-hover:bg-orange-100 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
        </span>
        <span>{{ 'Moje zamówienia' | translate }}</span>
        <svg class="w-4 h-4 ml-auto text-gray-300 group-hover:text-orange-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
      </button>

      <!-- Manage Account -->
      <button
        (click)="navigateToProfile()"
        class="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors duration-150 group cursor-pointer">
        <span class="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 group-hover:bg-orange-100 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
          </svg>
        </span>
        <span>{{ 'Zarządzaj kontem' | translate }}</span>
        <svg class="w-4 h-4 ml-auto text-gray-300 group-hover:text-orange-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
      </button>

      <!-- Divider -->
      <div class="my-1 mx-4 border-t border-gray-100"></div>

      <!-- Logout -->
      <button
        (click)="logout()"
        class="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-red-500 hover:bg-red-50 transition-colors duration-150 group cursor-pointer">
        <span class="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 group-hover:bg-red-100 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
          </svg>
        </span>
        <span>{{ 'Wyloguj się' | translate }}</span>
      </button>
    </div>
  </div>


  <!-- Unauthenticated User Content -->
  <ng-template #unauthenticatedContent>
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100">
      <h3 class="text-lg font-semibold text-gray-900 text-center">{{ 'Witamy' | translate }}</h3>
      <p class="text-sm text-gray-500 text-center mt-1">{{ 'Wybierz sposób kontynuowania' | translate }}</p>
    </div>

    <div class="p-6 space-y-4">
      
      <!-- Login Card -->
      <div class="group bg-gradient-to-r from-orange-50 to-orange-100/50 rounded-xl p-5 border border-orange-200/50 hover:shadow-lg hover:border-orange-300/50 transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
           (click)="navigateToLogin()">
        <div class="flex items-start space-x-4">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
              </svg>
            </div>
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="text-lg font-bold text-gray-900 mb-1">{{ 'Zaloguj się' | translate }}</h4>
            <p class="text-sm text-gray-600 leading-relaxed">
              {{ 'Zyskaj dostęp do konta i wygodnie zarządzaj swoimi zamówieniami.' | translate }}
            </p>
            <div class="mt-3 flex items-center text-orange-600 font-medium text-sm group-hover:text-orange-700 transition-colors">
              <span>{{ 'Przejdź do logowania' | translate }}</span>
              <svg class="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Register Card -->
      <div class="group bg-gradient-to-r from-gray-50 to-gray-100/50 rounded-xl p-5 border border-gray-200/50 hover:shadow-lg hover:border-gray-300/50 transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
           (click)="navigateToRegister()">
        <div class="flex items-start space-x-4">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-gray-600 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
              </svg>
            </div>
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="text-lg font-bold text-gray-900 mb-1">{{ 'Utwórz konto' | translate }}</h4>
            <p class="text-sm text-gray-600 leading-relaxed">
              {{ 'Załóż konto, aby sprawniej składać zamówienia i zarządzać danymi.' | translate }}
            </p>
            <div class="mt-3 flex items-center text-gray-600 font-medium text-sm group-hover:text-gray-700 transition-colors">
              <span>{{ 'Załóż konto' | translate }}</span>
              <svg class="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="px-6 py-4 bg-gray-50/50 rounded-b-2xl border-t border-gray-100">
      <div class="flex items-center justify-center space-x-4 text-xs text-gray-500">
        <span class="flex items-center">
          <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
          {{ 'Bezpieczne i szyfrowane' | translate }}
        </span>
        <span class="text-gray-300">•</span>
        <span class="flex items-center">
          <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
          {{ 'Szybko i wygodnie' | translate }}
        </span>
      </div>
    </div>
  </ng-template>

  <!-- Arrow pointing up -->
  <div class="absolute -top-2 right-6 w-4 h-4 bg-white border-l border-t border-gray-100 transform rotate-45 shadow-sm"></div>
</div>
